import OwlCarousel from 'react-owl-carousel';  
import { Link } from 'react-router-dom';
export default function RelatedPortfolio(){
    return(
        <section className="grey-bg2 portfolio-slide-area nav-style-1 pt-120 pb-90 pt-md-60 pb-md-30 pt-xs-60 pb-xs-30">
			<div className="container">
				<div className="row">
					<div className="col-md-6">
						<h2 className="see-more fs-20">Related Works</h2>
					</div>
				</div>			
				<OwlCarousel items={3}  
				className="portfolio-active2 owl-theme"  
				loop 
				dots={false}			  
				margin={20}
				responsive= {
					{
						'1':{
							items: 1
						},
						'768': {
							items: 2
						},
	
						'1200': {
							items: 3
						}
	
					}
					
				} >
					<div className="item">
							<div className="portfolio-wrapper2 mb-30">
								<img className="img-fluid" src="assets/img/portfolio/pr-4.jpg" alt="Portfolio Img" />
								<div className="portfolio-content">
									<p>Digital Marketing</p>
									<h3 className="portfolio-title text-white">Miranda Website Design</h3>
									<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
								</div>
							</div>
					</div>
					<div className="item">
						<div className="portfolio-wrapper2 mb-30">
							<img className="img-fluid" src="assets/img/portfolio/pr-11.jpg" alt="Portfolio Img" />
							<div className="portfolio-content">
								<p>Digital Marketing</p>
								<h3 className="portfolio-title text-white">Miranda Website Design</h3>
								<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
							</div>
						</div>
					</div>
					<div className="item">
						<div className="portfolio-wrapper2 mb-30">
							<img className="img-fluid" src="assets/img/portfolio/pr-12.jpg" alt="Portfolio Img" />
							<div className="portfolio-content">
								<p>Digital Marketing</p>
								<h3 className="portfolio-title text-white">Miranda Website Design</h3>
								<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
							</div>
						</div>
					</div>
					<div className="item">
						<div className="portfolio-wrapper2 mb-30">
							<img className="img-fluid" src="assets/img/portfolio/pr-13.jpg" alt="Portfolio Img"/>
							<div className="portfolio-content">
								<p>Digital Marketing</p>
								<h3 className="portfolio-title text-white">Miranda Website Design</h3>
								<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
							</div>
						</div>
					</div>
				</OwlCarousel>
			</div>
		</section>
    )
}